import { cn } from '@/lib/utils';
import { InquiryStatus, CreatorStatus } from '@/types/crm';

interface StatusBadgeProps {
  status: InquiryStatus | CreatorStatus;
  type?: 'inquiry' | 'creator';
}

const inquiryStatusConfig: Record<InquiryStatus, { label: string; className: string }> = {
  pending: { label: 'Pending', className: 'bg-status-pending/20 text-status-pending border-status-pending/30' },
  accepted: { label: 'Accepted', className: 'bg-status-accepted/20 text-status-accepted border-status-accepted/30' },
  in_progress: { label: 'In Progress', className: 'bg-status-in-progress/20 text-status-in-progress border-status-in-progress/30' },
  follow_up: { label: 'Follow Up', className: 'bg-status-follow-up/20 text-status-follow-up border-status-follow-up/30' },
  completed: { label: 'Completed', className: 'bg-status-completed/20 text-status-completed border-status-completed/30' },
  closed_lost: { label: 'Closed Lost', className: 'bg-status-closed/20 text-status-closed border-status-closed/30' },
};

const creatorStatusConfig: Record<CreatorStatus, { label: string; className: string }> = {
  invited: { label: 'Invited', className: 'bg-status-pending/20 text-status-pending border-status-pending/30' },
  accepted: { label: 'Accepted', className: 'bg-status-in-progress/20 text-status-in-progress border-status-in-progress/30' },
  active: { label: 'Active', className: 'bg-status-accepted/20 text-status-accepted border-status-accepted/30' },
  paused: { label: 'Paused', className: 'bg-status-closed/20 text-status-closed border-status-closed/30' },
};

export const StatusBadge = ({ status, type = 'inquiry' }: StatusBadgeProps) => {
  const config = type === 'inquiry' 
    ? inquiryStatusConfig[status as InquiryStatus]
    : creatorStatusConfig[status as CreatorStatus];

  return (
    <span className={cn('status-badge border', config.className)}>
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      {config.label}
    </span>
  );
};
